import type Paginated from 'app/core/paginable';
import Env from 'env';

import { headers, HttpAxios, promiseWith } from './httpAxios';

export class HttpApiSecurity extends HttpAxios {
  /**
   *
   */
  constructor() {
    super({ baseURL: Env.baseUrlSecurityApi, headers: headers });
  }

  async paginate<T = any, R = Paginated<T>>(
    baseUrl: string,
    page: number,
    pageSize: number,
    params: any = undefined
  ): Promise<R> {
    let queryParams = '';
    if (params) {
      const searchParams = new URLSearchParams();
      Object.keys(params).forEach((key) => {
        if (params[key] !== null && params[key] !== undefined) {
          searchParams.append(key, String(params[key]));
        }
      });
      queryParams = `&${searchParams.toString()}`;
    }
    const response = await this.service.get(
      `${baseUrl}?page=${page}&pageSize=${pageSize}${queryParams}`
    );
    return promiseWith<R>(response.data);
  }
}

export default new HttpApiSecurity();
